import { filtersAtom, backendFiltersAtom } from "@/hooks/useCurrentFilters";
import { useAtom } from "jotai";
import FilterBuilder from "./FilterBuilder";
import Separator from "../../lib/Separator";
import { usePushQueryToRouter } from "@/utils/functions/pushQueryToRouter";

interface Props {
  PC?: boolean;
}
const Filter: React.FC<Props> = ({ PC = false }) => {
  const pushQueryToRouter = usePushQueryToRouter();
  const [filterKeys, setFilterKeys] = useAtom(filtersAtom);
  const [filters] = useAtom(backendFiltersAtom);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      {filters?.map((filter, key) => (
        <div key={key}>
          <Separator
            secondary
            startLabel={filter.configurations.title}
            marginBottom={8}
          />
          <FilterBuilder
            filter={filter}
            state={filterKeys[filter.configurations.key]}
            setState={(state) => {
              setFilterKeys({
                ...filterKeys,
                [filter.configurations.key]: state,
              });
              if (PC) {
                pushQueryToRouter.pushQueryToRouter(
                  [{ name: filter.configurations.key, val: state.join(",") }],
                  true
                );
              }
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default Filter;
